import styled from 'styled-components';

export const MOBILE_WIDTH_BREAK_POINT = 960;

/**
 * @deprecated: use https://material-ui.com/layout/hidden/ instead.
 */
export const DesktopOnly = styled.div`
  display: none;
  position: relative;
  pointer-events: none;
  @media (min-width: ${MOBILE_WIDTH_BREAK_POINT}px) {
    display: block;
  }
`;

/**
 * @deprecated: use https://material-ui.com/layout/hidden/ instead.
 */
export const MobileOnly = styled.div`
  @media (min-width: ${MOBILE_WIDTH_BREAK_POINT}px) {
    display: none;
  }
`;

export const isIphoneX = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const ratio = window.devicePixelRatio || 1;
  const screen = {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio,
  };
  const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  if (isIos && screen.width >= 1125 && screen.height >= 2436) {
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    return true;
  }

  return false;
};
